function cov_24wroiy69t() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChatVersionTwo.tsx";
  var hash = "0b978b63597e95d4d2a43e686761e9ada12caa70";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChatVersionTwo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0b978b63597e95d4d2a43e686761e9ada12caa70"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24wroiy69t = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24wroiy69t();
var Icon = (cov_24wroiy69t().s[0]++, {
  name: 'chat-2',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 18H19C20.6569 18 22 16.6569 22 15V2H5C3.34315 2 2 3.34315 2 5V18H8L11.75 22L16 18ZM11.8606 18.4627L15.0086 15.5H19C19.2761 15.5 19.5 15.2761 19.5 15V4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V15.5H9.08308L11.8606 18.4627Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 12C6.75 11.3096 7.30964 10.75 8 10.75H16C16.6904 10.75 17.25 11.3096 17.25 12C17.25 12.6904 16.6904 13.25 16 13.25H8C7.30964 13.25 6.75 12.6904 6.75 12Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 8C6.75 7.30964 7.30964 6.75 8 6.75H16C16.6904 6.75 17.25 7.30964 17.25 8C17.25 8.69036 16.6904 9.25 16 9.25H8C7.30964 9.25 6.75 8.69036 6.75 8Z\" fill=\"currentColor\"/>"
});
export default Icon;